import { configString } from 'config/appConfigUtils';
import { searchAlgoliaConfig } from 'modules/search/algolia/searchAlgoliaConfig';
import { algoliaSearch } from 'utils/algolia/algoliaSearch';
import { algoliaBuildFilterString } from 'utils/algolia/helpers/algoliaBuildFilterString';

export async function searchAlgoliaFetchFacetCounts({
  filters,
  facets = ['*'],
  indexName = configString('algolia', 'siteIndexName'),
}: {
  filters: Record<string, string | string[]>;
  facets: string[];
  indexName: string;
}) {
  const response = await algoliaSearch({
    config: searchAlgoliaConfig(),
    query: '',
    options: {
      facets,
      filters: algoliaBuildFilterString(filters),
    },
    indexName,
    analytics: false,
  });

  return response.facets;
}
